import api from './api';

export const verifyPayment = async (comercioKey: string, pedidoId: string, sessionId: string) => {
  try {
    const response = await api.post(`/comercios/${comercioKey}/pedidos/${pedidoId}/verificar-pago`, {
      sessionId,
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying payment:', error);
    throw error;
  }
};